import { Provider } from "@angular/core";
import { NZ_ICONS } from "ng-zorro-antd/icon";
import {
  UserDeleteOutline,
  PlusCircleOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  MenuOutline,
  LogoutOutline,
  FilterOutline,
  CloudServerOutline,
  DeleteOutline,
  ExportOutline,
  ImportOutline,
  ProfileOutline,
  DatabaseOutline,
  HolderOutline,
  CloseOutline,
  PlusOutline,
  MinusOutline,
  SyncOutline,
  ReadOutline,
  SettingOutline,
  ApiOutline,
  StopOutline,
  CloseCircleOutline,
  UploadOutline,
  VideoCameraOutline,
  DesktopOutline,
  TagsOutline,
  ContainerOutline,
  DownloadOutline,
  RocketOutline,
  FolderOutline,
  FolderOpenOutline,
  ShoppingOutline,
  LeftOutline,
  ArrowLeftOutline,
  AlertOutline,
  WarningOutline,
  MoreOutline,
  ThunderboltOutline,
  CodeOutline,
  BookOutline,
  SelectOutline,
  FileSearchOutline,
  DeploymentUnitOutline,
  ReloadOutline,
  FileZipOutline,
  ArrowUpOutline,
  BellOutline,
  ArrowDownOutline,
} from "@ant-design/icons-angular/icons";

const icons = [
  UserDeleteOutline,
  PlusCircleOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  MenuOutline,
  LogoutOutline,
  FilterOutline,
  CloudServerOutline,
  DeleteOutline,
  ExportOutline,
  ImportOutline,
  ProfileOutline,
  DatabaseOutline,
  HolderOutline,
  CloseOutline,
  PlusOutline,
  MinusOutline,
  SyncOutline,
  ReadOutline,
  SettingOutline,
  ApiOutline,
  StopOutline,
  CloseCircleOutline,
  UploadOutline,
  VideoCameraOutline,
  DesktopOutline,
  TagsOutline,
  ContainerOutline,
  DownloadOutline,
  RocketOutline,
  FolderOutline,
  FolderOpenOutline,
  ShoppingOutline,
  LeftOutline,
  ArrowLeftOutline,
  AlertOutline,
  WarningOutline,
  MoreOutline,
  ThunderboltOutline,
  BookOutline,
  CodeOutline,
  SelectOutline,
  FileSearchOutline,
  DeploymentUnitOutline,
  ReloadOutline,
  DesktopOutline,
  FileZipOutline,
  ArrowUpOutline,
  BellOutline,
  ArrowDownOutline,
];

export const provideNzIcons = (): Provider[] => {
  return [{ provide: NZ_ICONS, useValue: icons }];
};
